import { RunDto, RunResultsHistoricAggregate } from "@custom-types/modelRun"
import { ChartData } from "chart.js"
import {
  DataSetsWithMetadata,
  buildTimeSeriesChartData,
  buildTimeSeriesDataSets,
} from "@features/results/Result/ChartsContainer/BarStringsChart.utils"
import { useMemo } from "react"

type UseBarStringsChartDataProps = {
  aggregateData: RunResultsHistoricAggregate | undefined
  lagShift: number
  runs: RunDto[]
  isStacked: boolean
  showAsPercentage?: boolean
}

export const useBarStringsChartData = ({
  aggregateData,
  lagShift,
  runs,
  isStacked,
  showAsPercentage = true,
}: UseBarStringsChartDataProps): {
  timestepLabels: number[]
  chartData: ChartData<"bar", number[], number>
  dataSets: DataSetsWithMetadata
} => {
  const { timestepLabels, dataSets } = useMemo(
    () => buildTimeSeriesDataSets({ aggregateResults: aggregateData?.results, lagShift, runs }),
    [aggregateData, lagShift, runs],
  )

  const chartData = useMemo<ChartData<"bar", number[], number>>(() => {
    return buildTimeSeriesChartData(dataSets, timestepLabels, isStacked, showAsPercentage, runs)
  }, [dataSets, isStacked, showAsPercentage, timestepLabels, runs])

  return {
    timestepLabels,
    chartData,
    dataSets,
  }
}
